const e = () => typeof window.noticePopTime != "string" ? "1679994000000" : window.noticePopTime;
export {
  e as default
};
